import { Dispatch, SetStateAction } from 'react';
import { isMobileResolution, scrollToTop } from '@/utils';
import ArrowLeftIcon from '@/assets/icons/arrow-left.svg?react';
import ArrowRightIcon from '@/assets/icons/arrow-right.svg?react';
import styles from './PaginationControls.module.scss';

interface IPaginationControlsProps {
  offset: number;
  total: number;
  pageSize: number;
  setOffset: Dispatch<SetStateAction<number>>;
}

function PaginationControls({ offset, total, pageSize, setOffset }: IPaginationControlsProps) {
  const from = offset + (total ? 1 : 0); // if there are results start from 1 otherwise 0
  const to = Math.min(offset + pageSize, total);
  const nextPage = () => {
    if (offset + pageSize < total) setOffset(offset + pageSize);
    if (isMobileResolution) scrollToTop();
  };
  const prevPage = () => {
    if (offset - pageSize >= 0) setOffset(offset - pageSize);
    if (isMobileResolution) scrollToTop();
  };

  return (
    <div className={styles.paginationControls}>
      <button type="button" aria-label="Previous page" disabled={offset === 0} onClick={prevPage}>
        <ArrowLeftIcon className={`${styles.arrow} ${offset === 0 ? styles.inactiveArrow : ''}`} />
      </button>
      <span>{`${from}–${to} of ${total}`}</span>
      <button type="button" aria-label="Next page" disabled={offset + pageSize >= total} onClick={nextPage}>
        <ArrowRightIcon className={`${styles.arrow} ${offset + pageSize >= total ? styles.inactiveArrow : ''}`} />
      </button>
    </div>
  );
}

export default PaginationControls;
